import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import LayoutV2 from "@/components/layout/LayoutV2";
import Home from "@/pages/Home";
import HomeV2 from "@/pages/HomeV2";
import About from "@/pages/About";
import SecurityFilmsResidential from "@/pages/SecurityFilmsResidential";
import SecurityFilmsCommercial from "@/pages/SecurityFilmsCommercial";
import SecurityCameras from "@/pages/SecurityCameras";
import BlindsShutters from "@/pages/BlindsShutters";
import Contact from "@/pages/Contact";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout><Home /></Layout>} />
                    <Route path="/about" element={<Layout><About /></Layout>} />
                    <Route path="/security-films/residential" element={<Layout><SecurityFilmsResidential /></Layout>} />
                    <Route path="/security-films/commercial" element={<Layout><SecurityFilmsCommercial /></Layout>} />
                    <Route path="/security-cameras" element={<Layout><SecurityCameras /></Layout>} />
                    <Route path="/blinds-shutters" element={<Layout><BlindsShutters /></Layout>} />
                    <Route path="/contact" element={<Layout><Contact /></Layout>} />
                    <Route path="/v2" element={<LayoutV2><HomeV2 /></LayoutV2>} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
